import inboxPlusStore from '../store/Store';
import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';

export default function isNonInboxTabEnabled(): boolean {
    const nonInboxPivots = inboxPlusStore.inboxPlusPivots.filter(
        pivot =>
            pivot.isEnabled && pivot.InboxClassificationFilter !== InboxClassificationFilter.None
    );
    return nonInboxPivots.length > 0;
}
